import styles from "./Navbar2.module.css";

const Navbar2 = () => {
    return (
        <>
            <div className={styles.Navbar2_maindiv}>
                <p>Tops</p>
                <p>Bottoms</p>
                <p>Dresses + Rompers</p>
                <p>Hoodies + Sweats</p>
                <p>Loungewear</p>
                <p>Swimwear</p>
                <p>Outerwear</p>
                <p>Accessories</p>
                <p>Bralettes + Undies</p>
            </div>
        </>
    );
};

export default Navbar2;
